import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { isObservable, of } from 'rxjs';

class SliderComponent {
    constructor() {
        this.selected = false;
        this.disabled = false;
        this.beforeToggleChange = () => true;
        this.selectedChange = new EventEmitter();
    }
    onChange(event) {
        let canChangeToggle = this.beforeToggleChange();
        if (!isObservable(canChangeToggle)) {
            canChangeToggle = of(canChangeToggle);
        }
        canChangeToggle.subscribe((canChange) => {
            if (!canChange) {
                event.target.checked = !event.target.checked;
            }
            this.selectedChange.emit(event.target.checked);
        });
    }
}
SliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: SliderComponent, selector: "ps-ui-slider", inputs: { selected: "selected", disabled: "disabled", beforeToggleChange: "beforeToggleChange" }, outputs: { selectedChange: "selectedChange" }, ngImport: i0, template: "<label class=\"switch\" [class.disabled]=\"disabled\">\n  <input\n    type=\"checkbox\"\n    [checked]=\"selected\"\n    (change)=\"onChange($event)\"\n    [attr.disabled]=\"disabled ? '' : null\"\n  />\n  <span class=\"slider round\"></span>\n</label>\n", styles: [".switch{position:relative;display:inline-block;width:46px;height:22px;vertical-align:0px}.switch input{opacity:0;width:0;height:0}.slider{background:#a6a6a6;position:absolute;cursor:pointer;inset:0;transition:.4s}.slider:before{position:absolute;content:\"\";height:20px;width:20px;left:1px;bottom:1px;background-color:#fff;transition:.4s}input:checked+.slider{background-color:#4a91c5}input:focus+.slider{box-shadow:0 0 1px #4a91c5}input:checked+.slider:before{transform:translate(24px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}.switch.disabled{opacity:.6}.switch.disabled .slider{cursor:not-allowed}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ps-ui-slider', template: "<label class=\"switch\" [class.disabled]=\"disabled\">\n  <input\n    type=\"checkbox\"\n    [checked]=\"selected\"\n    (change)=\"onChange($event)\"\n    [attr.disabled]=\"disabled ? '' : null\"\n  />\n  <span class=\"slider round\"></span>\n</label>\n", styles: [".switch{position:relative;display:inline-block;width:46px;height:22px;vertical-align:0px}.switch input{opacity:0;width:0;height:0}.slider{background:#a6a6a6;position:absolute;cursor:pointer;inset:0;transition:.4s}.slider:before{position:absolute;content:\"\";height:20px;width:20px;left:1px;bottom:1px;background-color:#fff;transition:.4s}input:checked+.slider{background-color:#4a91c5}input:focus+.slider{box-shadow:0 0 1px #4a91c5}input:checked+.slider:before{transform:translate(24px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}.switch.disabled{opacity:.6}.switch.disabled .slider{cursor:not-allowed}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { selected: [{
                type: Input
            }], disabled: [{
                type: Input
            }], beforeToggleChange: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }] } });

class SliderModule {
}
SliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderModule, declarations: [SliderComponent], imports: [CommonModule], exports: [SliderComponent] });
SliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SliderComponent],
                    exports: [SliderComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SliderComponent, SliderModule };
